var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-login"},[_c('div',{staticClass:"bottom"}),_c('h4',[_vm._v("选择登录方式")]),_c('router-link',{attrs:{"tag":"button","to":"/login"}},[_vm._v("手机登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }